<template>
  <div class="bus-audit-process-bar">
    <div
      class="process-item"
      v-for="(item, index) in data"
      :key="index"
      :class="item.isJoinApprove ? 'active' : ''"
    >
      <div class="top">
        <div class="item-num">{{index + 1}}</div>
        <div class="label">{{item.flowNodeName}}</div>
      </div>
      <div class="tips">{{item.isJoinApprove ? $t('base_process_bar.zghjcysp') : ''}}</div>
    </div>
  </div>
</template>

<script>
export default {
  name: '',
  mixins: [],
  components: {},
  props: {
    data: {
      type: Array,
      default() {
        return [];
      },
    },
  },
  data() {
    return {};
  },
  computed: {},
  watch: {},
  filters: {},
  directives: {},
  methods: {},
  created() {},
  mounted() {},
};
</script>

<style lang="scss">
.bus-audit-process-bar {
  overflow: hidden;
  .process-item {
    float: left;
    margin-top: 15px;
    position: relative;
    &:nth-child(n + 2) {
      $ml: 60px;
      $lineW: 36px;
      margin-left: $ml;
      .top {
        &::before {
          content: ' ';
          position: absolute;
          top: 0;
          bottom: 0;
          left: -1 * $ml + ($ml - $lineW) / 2;
          height: 1px;
          width: $lineW;
          background: #ccc;
          margin: auto;
        }
      }
    }
    &.active {
      .top {
        .item-num {
          box-shadow: 0px 0px 0px 1px #0d9ae0 inset;
          background: #0d9ae0;
          color: #fff;
        }
      }
    }
    .top {
      $lh: 40px;
      $r: 26px;
      height: $lh;
      position: relative;
      .item-num {
        float: left;
        border-radius: 100%;
        width: $r;
        height: $r;
        box-shadow: 0px 0px 0px 1px #ccc inset;
        line-height: $r;
        text-align: center;
        font-size: 12px;
        margin-top: ($lh - $r) / 2;
      }
      .label {
        float: left;
        padding-left: 10px;
        font-size: 14px;
        line-height: $lh;
      }
    }
    .tips {
      font-size: 12px;
      word-break: break-all;
      line-height: 24px;
      text-align: center;
    }
  }
}
</style>
